import { useRef, useCallback } from "react";

/**
 * Returns props to spread onto a modal backdrop so that clicks ONLY dismiss
 * when both the press AND release happen on the backdrop itself (not bubbled
 * from an input / button inside). This fixes the iOS Safari quirk where
 * tapping an input inside a modal can register a click on the backdrop and
 * close the modal unexpectedly.
 */
export default function useBackdropDismiss(onDismiss) {
  const startedOnSelf = useRef(false);

  const onPointerDown = useCallback((e) => {
    startedOnSelf.current = e.target === e.currentTarget;
  }, []);

  const onPointerUp = useCallback(
    (e) => {
      if (startedOnSelf.current && e.target === e.currentTarget) onDismiss();
      startedOnSelf.current = false;
    },
    [onDismiss],
  );

  return { onPointerDown, onPointerUp };
}
